<template>
  <div :class="classnames" @click="handleClick">
    <div :class="`${ns}__flexbox`">
      <template v-if="this.$slots.icon">
        <div :class="`${ns}__icon`">
          <slot name="icon" />
        </div>
      </template>

      <template v-if="this.$slots.label">
        <div :class="`${ns}__label`">
          <slot name="label" />
        </div>
      </template>
      <slot />
    </div>
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'tabs-nav-item'

  const modifiers = {
    isFocused: 'is-focused'
  }

  export default {
    name: 'TabsNavItem',
    components: {},
    mixins: [ bem ],
    props: {
      focusedTabId: {
        type: Number
      },
      id: {
        type: Number
      }
    },
    data: function () {
      return {}
    },
    computed: {
      isFocused: function () {
        const isFocused = this.focusedTabId === this.id

        return isFocused
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isFocused = this.isFocused && modifiers.isFocused

        return [ isFocused ]
      },
      handleClick: function () {
        this.$emit('click', this.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Tabs/TabsNavItem.vue